import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MARKETING_PLUS_SUITE } from 'self-service-api/constants/BundleTypes';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import * as UnitScopes from 'self-service-api/constants/UnitScopes';
import { CONTACT, USER } from 'self-service-api/constants/UnitTypes';
import { useAppSelector } from '../../reducers';
import { bundleProductForBundleTypeAndProductLevelSelector, currentSkuIdForProductSelector, isSalesOrServiceProOrEntSkuSelector, quantityPackForProductVersionSelector, skuSelector } from '../../selectors/ProductsSelectors';
import { usePricingLibSelector } from '../../selectors/SelectorUtils';

// Cannot be used with a sku with multiple quantityPacks
export const useSkuAdditionalUnits = ({
  productLevel,
  productLine,
  bundleType
}) => {
  const skuId = useAppSelector(state => {
    if (bundleType) {
      const bundleProduct = bundleProductForBundleTypeAndProductLevelSelector(state, {
        bundleType,
        productLevel
      });
      return bundleProduct === null || bundleProduct === void 0 ? void 0 : bundleProduct.currentSkuId;
    }
    return currentSkuIdForProductSelector(state, {
      productLine,
      productLevel
    });
  });
  const isSeatsUngated = usePricingLibSelector(getIsUngatedForSeats);
  const additionalUnitSkuId = useSelector(state => {
    if (!skuId) {
      return null;
    }
    const isSkuQuantifiable = skuSelector(state, {
      skuId
    }).quantifiable;
    if (isSalesOrServiceProOrEntSkuSelector(state, {
      skuId
    }) && isSkuQuantifiable && isSeatsUngated) {
      return skuId;
    } else {
      const quantityPack = quantityPackForProductVersionSelector(state, {
        productVersionSkuId: skuId,
        unitType: productLine === MARKETING || bundleType === MARKETING_PLUS_SUITE ? CONTACT : USER,
        unitScope: bundleType === MARKETING_PLUS_SUITE ? UnitScopes.MARKETING : productLine
      });
      return quantityPack && quantityPack.skuId || null;
    }
  });
  const isAdditionalUnitSkuIdAQuantityPack = useSelector(state => {
    if (!additionalUnitSkuId) {
      return false;
    }
    const {
      skuType
    } = skuSelector(state, {
      skuId: additionalUnitSkuId
    });
    return skuType === QUANTITY_PACK;
  });
  const [additionalUnitQuantity, setAdditionalUnitQuantity] = useState(0);
  return {
    additionalUnitSkuId,
    isAdditionalUnitSkuIdAQuantityPack,
    additionalUnitQuantity,
    setAdditionalUnitQuantity,
    skuId
  };
};